import { render } from "./Registration.vue?vue&type=template&id=ebe56f4a&ts=true"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=ebe56f4a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__